import { useLanguage } from "@/i18n/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang, t } = useLanguage();

  return (
    <div
      role="group"
      aria-label={t.common.languageToggleAria}
      className={`inline-flex items-center rounded-full border border-brand-soft bg-white p-[3px] ${className}`}
      data-testid="language-toggle"
    >
      {["en", "es"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            data-testid={`lang-${code}-btn`}
            aria-pressed={active}
            className={`px-3 py-1 text-xs font-display font-semibold rounded-full transition-all duration-200 ${
              active ? "text-white" : "text-[color:var(--brand-primary)] hover:bg-[color:var(--brand-surface-soft)]"
            }`}
            style={{
              background: active ? "var(--brand-primary)" : "transparent",
              minWidth: 38,
            }}
          >
            {code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
